import React, { useState } from "react";
import { X } from "lucide-react";
import WhatsAppMockPhone from "../../simulator/components/WhatsAppMockPhone";
import { buildConfigConfirmationText, buildConfigReminderText, buildDemoReminderText } from "../demos/configCallMessages";

// Preview de lo que recibirá el lead al agendarle una llamada. Los textos son los cuerpos
// reales de las plantillas (configCallMessages.js).
//   kind "config" → dos pestañas: confirmación (config_confirmada_crm) + recordatorio
//                   (recordatorio_config_crm).
//   kind "demo"   → solo el recordatorio de la demo (recordatorio_demo_crm); su
//                   confirmación lleva póster sectorial y viaja por otra plantilla.
export default function ConfigCallPreviewModal({ open, onClose, vals, kind = "config" }) {
  const [tab, setTab] = useState(kind === "demo" ? "rem" : "conf");
  if (!open) return null;
  const isDemo = kind === "demo";
  const confText = buildConfigConfirmationText(vals);
  const remText = isDemo
    ? `*RECORDATORIO DE PRESENTACIÓN*\n\n${buildDemoReminderText(vals)}`
    : `*RECORDATORIO DE TU LLAMADA DE CONFIGURACIÓN*\n\n${buildConfigReminderText(vals)}`;
  const activeTab = isDemo ? "rem" : tab;
  const text = activeTab === "conf" ? confText : remText;
  return (
    <div className="fixed inset-0 z-[80] bg-black/50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl p-4 w-full max-w-sm max-h-[92vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-black text-sm">Así le llegará al lead</h3>
          <button type="button" onClick={onClose} className="p-1.5 rounded-lg hover:bg-gray-100"><X size={16} /></button>
        </div>
        {!isDemo && (
          <div className="flex gap-2 mb-3">
            {[["conf", "Confirmación"], ["rem", "Recordatorio 24h/2h"]].map(([k, l]) => (
              <button key={k} type="button" onClick={() => setTab(k)}
                className={`px-3 py-1.5 rounded-lg text-xs font-bold border ${tab === k ? "bg-sky-600 text-white border-sky-600" : "text-gray-600"}`}>
                {l}
              </button>
            ))}
          </div>
        )}
        {isDemo && (
          <div className="mb-3 text-xs font-bold text-emerald-700">Recordatorio 24h/2h de la demo</div>
        )}
        <WhatsAppMockPhone
          senderName="ConextCRM"
          message={text}
          cta={activeTab === "rem" ? "Confirmar cita" : null}
          footer={activeTab === "conf" ? "ConextCRM" : null}
          height={440}
        />
        {activeTab === "rem" && (
          <p className="text-[11px] text-gray-500 mt-2">
            Se envía 24 h y 2 h antes de la llamada. Sin botón de cancelar a propósito: los cambios se hablan con {isDemo ? "el closer" : "el asesor"}.
          </p>
        )}
      </div>
    </div>
  );
}
